/**
 * @typedef {object} QuoteRow
 * @property {string} label - organisatienaam
 * @property {string} quote - het letterlijke citaat bij dit effect
 * @property {string} [explanation] - het waarom, in de woorden van de geïnterviewde
 * @property {'begeleider'|'deelnemer'} role
 * @property {({kind: string, label: string, provisional: boolean}|null)} [quality]
 */

/**
 * Citaten uit interviews, per organisatie. Het weergavecontract `quotes`.
 *
 * Illustreert en verklaart; bewijst niet. Elke rij staat onder voorbehoud en
 * de bron heet 'uit interviews' — hier komt nooit ISS-vocabulaire.
 * AI-CONTEXT: See docs/features/intelligence-interviews-op-thema.md
 *
 * @param {object} props
 * @param {Array<QuoteRow>} props.rows
 * @param {boolean} [props.measurable]
 */
const QuotesRender = ({ rows, measurable = true }) => {
    if (measurable === false || !rows || rows.length === 0) {
        return <p className="intelligence-state">Geen citaten voor dit thema.</p>
    }
    return (
        <div className="intelligence-agenda-list">
            {rows.map((row, index) => (
                <div key={`${row.label}-${index}`} className="intelligence-agenda-row intelligence-ranking__row--provisional">
                    <div className="intelligence-agenda-row__body">
                        <p className="intelligence-agenda-row__title">
                            {row.label} <span className="intelligence-badge intelligence-badge--dimensie">{row.role}</span>
                        </p>
                        <blockquote className="intelligence-quote">{row.quote}</blockquote>
                        {row.explanation && <span className="intelligence-agenda-row__stand">{row.explanation}</span>}
                        {row.quality && row.quality.label && (
                            <span className="intelligence-agenda-row__stand">{row.quality.label}</span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default QuotesRender
